import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

type ConfigServiceOpsKeys = Values<typeof OPS>;
type ConfigServiceExperimentKeys = Values<typeof EXPERIMENT>;
type ConfigServiceReleaseKeys = Values<typeof RELEASE>;
type ConfigServiceDataKeys = Values<typeof DATA>;

export type ConfigServiceKeys =
  | ConfigServiceOpsKeys
  | ConfigServiceExperimentKeys
  | ConfigServiceReleaseKeys
  | ConfigServiceDataKeys;

export const EXPERIMENT = {
  ACORN_AD_FILTERING_LOGIC_DISABLED: 'acorn_ad_filtering_logic_disabled',
  AIRLINE_LOGOS_IN_RESULTS: 'airline_logos_in_results',
  ANONYMOUS_UTID_PROPAGATION_EXPLICIT_TLD_REDIRECT:
    'anonymous_utid_propagation_explicit_tld_redirect',
  ASK_SKYSCANNER_LOCALES_ENABLED: 'ask_skyscanner_locales_enabled',
  AUTOSUGGEST_EXP: 'AutosuggestExp',
  BAGS_EXP: 'BagsExp',
  BOOKING_PANEL_S2L_COPY_EXPERIMENT: 'BookingPanelS2LCopyExperiment',
  BOOKING_PANEL_S2L_CTA_EXPERIMENT: 'Booking_Panel_S2L_CTA_Experiment',
  BOOKING_PANEL_WITHOUT_MODAL: 'booking_panel_without_modal',
  CAN_SEE_PACKAGES_WEBSITE: 'can_see_packages_website',
  CARS_COPY_HEADER_TAB_ENABLED: 'cars_copy_header_tab_enabled',
  COLLAPSE_FLIGHT_PRICING_OPTIONS: 'CollapseFlightPricingOptions',
  COPY_OPTIONS_FOR_PRICE_GRID_ENTRY_POINT: 'CopyOptionsForPriceGridEntryPoint',
  CRUISES_TAB_LINK: 'cruises_tab_link',
  ENABLE_ACORN_INLINE_SEO_CREATIVES: 'EnableAcornInlineSeoCreatives',
  ENABLE_ACORN_INLINE_TRAVEL_ENTITY: 'EnableAcornInlineTravelEntity',
  ENABLE_AIRLINE_PRICES_ON_SEARCH_RESULTS: 'enable_airline_prices_on_search_results',
  ENABLE_BAGGAGE_INCLUSION_ICONS: 'EnableBaggageInclusionIcons',
  ENABLE_BANANA_HEADER_G_C: 'EnableBananaHeaderGC',
  ENABLE_BANANA_INLINE_ADS_DATA: 'EnableBananaInlineAdsData',
  ENABLE_BANANA_SEARCH_PARAMS_VIA_WINDOW: 'EnableBananaSearchParamsViaWindow',
  ENABLE_BLUE_MINI_GRID: 'EnableBlueMiniGrid',
  ENABLE_BOOK_IT_FOR_ME: 'EnableBookItForMe',
  ENABLE_CALENDAR_PRICES: 'EnableCalendarPrices',
  ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_DESKTOP:
    'EnableCalendarPricesProgressiveLoadingDesktop',
  ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_MOBILE: 'EnableCalendarPricesProgressiveLoadingMobile',
  ENABLE_CALENDAR_PRICES_V2_ENDPOINTS: 'EnableCalendarPricesV2Endpoints',
  ENABLE_CAR_HIRE_INDICATIVE_PRICE_IN_BOOKING_PANEL: 'EnableCarHireIndicativePriceInBookingPanel',
  ENABLE_COMBINED_EXPLORE_VIDEOS: 'EnableCombinedExploreVideos',
  ENABLE_CRUISES_TAB: 'enable_cruises_tab',
  ENABLE_DESKTOP_BOOKING_PANEL: 'EnableDesktopBookingPanel',
  ENABLE_DOLPHINS_FLIGHT_FINDER: 'EnableDolphinsFlightFinder',
  ENABLE_ENFORCE_TRIP_TYPE: 'EnableEnforceTripType',
  ENABLE_EVENTS_ENTRY: 'EnableEventsEntry',
  ENABLE_EXPANDABLE_PRICING_OPTION: 'EnableExpandablePricingOption',
  ENABLE_EXPLORE_AI: 'EnableExploreAI',
  ENABLE_EXPLORE_BY_EXPERIENCE: 'EnableExploreByExperience',
  ENABLE_EXPLORE_COUNTRIES_FILTER_POC: 'enable_explore_countries_filter_poc',
  ENABLE_EXPLORE_DEAL_BADGES: 'enable_explore_deal_badges',
  ENABLE_EXPLORE_SPONSORED_CONTENT: 'enable_explore_sponsored_content',
  ENABLE_FLEXIBLE_DATE_SELECTION_WITH_BACK_TO_DEPART: 'EnableFlexibleDateSelectionWithBackToDepart',
  ENABLE_FLEXIBLE_DATE_SELECTION_WITH_STICK_TO_RETURN:
    'EnableFlexibleDateSelectionWithStickToReturn',
  ENABLE_FULL_SKELETON_RESULTS: 'EnableFullSkeletonResults',
  ENABLE_GET_PRICE_ALERTS_TOGGLE_TEXT: 'EnableGetPriceAlertsToggleText',
  ENABLE_HIDDEN_GEMS_NLS: 'EnableHiddenGemsInNLS',
  ENABLE_HOMEPAGE_HERO_VIDEO: 'enable_homepage_hero_video',
  ENABLE_HOTELS_INDICATIVE_PRICE_IN_BOOKING_PANEL: 'EnableHotelsIndicativePriceInBookingPanel',
  ENABLE_HOTELS_RECOMMENDATIONS_IN_BOOKING_PANEL: 'EnableHotelsRecommendationsInBookingPanel',
  ENABLE_HOTELS_RECOMMENDATIONS_IN_RYANAIR_B_P: 'EnableHotelsRecommendationsInRyanairBP',
  ENABLE_HOTELS_TAB_DAYVIEW_LANDING: 'enable_hotels_tab_dayview_landing',
  ENABLE_INDICATIVE_PRICING_ORDERING: 'EnableIndicativePricingOrdering',
  ENABLE_INLINE_HOTELS_ADS: 'enable_inline_hotels_ads',
  ENABLE_INVALID_JSON_RESPONSE_HANDLING: 'EnableInvalidJsonResponseHandling',
  ENABLE_KAKAO_PAY_CASHBACK_MESSAGE: 'enable_kakao_pay_cashback_message',
  ENABLE_LOGIN_FORM_AUTO_PROMPT: 'EnableLoginFormAutoPrompt',
  ENABLE_LOGIN_FORM_BUNDLED_CONSENT: 'EnableLoginFormBundledConsent',
  ENABLE_LOYALTY_DISCOUNTS: 'enable_loyalty_discounts',
  ENABLE_MULTICITY_ON_BANANA: 'EnableMulticityOnBanana',
  ENABLE_MULTICITY_SAVE: 'EnableMulticitySave',
  ENABLE_MULTIPLE_CARRIERS_FOR_UPSELL: 'EnableMultipleCarriersForUpsell',
  ENABLE_NEW_TRANSLATIONS_XSELL__B_P: 'enable_new_translations_xsell_BP',
  ENABLE_NEW_TRANSLATIONS_XSELL__B_P_MWEB: 'enable_new_translations_xsell_BP_mweb',
  ENABLE_PACKAGES_PARALLEL_SEARCH_OPTION: 'EnablePackagesParallelSearchOption',
  ENABLE_PACKAGES_UP_SELL: 'EnablePackagesUpSell',
  ENABLE_PARALLEL_SEARCH_MULTI_LINE: 'EnableParallelSearchMultiLine',
  ENABLE_PARALLEL_SEARCH_OPTION: 'EnableParallelSearchOption',
  ENABLE_PARTNER_CARD_PRICING_REDESIGN: 'enable_partner_card_pricing_redesign',
  ENABLE_PAYMENT_DISCOUNTS_PHASE_2: 'enable_payment_discounts_phase_2',
  ENABLE_PQS_HOTEL_CARD_NEW_STYLE: 'enable_pqs_hotel_card_new_style',
  ENABLE_PQS_HOTEL_LIST_ON_MWEB: 'enable_pqs_hotel_list_on_mweb',
  ENABLE_PQS_RATING_ALIGNMENT_ACORN: 'enable_pqs_rating_alignment_acorn',
  ENABLE_PQS_RATING_ALIGNMENT_BANANA: 'enable_pqs_rating_alignment_banana',
  ENABLE_PQS_SUMMARY: 'EnablePqsSummary',
  ENABLE_PRICE_ALERTS_TOGGLE_SAVE_TEXT: 'EnablePriceAlertsToggleSaveText',
  ENABLE_PRICE_ALERT_TOGGLE: 'enable_price_alert_toggle',
  ENABLE_PRICE_BANDS_DYNAMIC_FILTERING: 'enablePriceBandsDynamicFiltering',
  ENABLE_PRICE_BANDS_EMPTY_LOADING_STATE: 'enablePriceBandsEmptyLoadingState',
  ENABLE_PRICE_BANDS_FLIGHT_SEARCH_RESULTS: 'EnablePriceBandsFlightSearchResults',
  ENABLE_PRICE_BANDS_MESSAGE_LOADING_STATE: 'enablePriceBandsMessageLoadingState',
  ENABLE_PRICE_BANDS_STATIC_FILTERING: 'enablePriceBandsStaticFiltering',
  ENABLE_PRICE_GUARANTEE: 'enablePriceGuarantee',
  ENABLE_PRICE_REFRESH: 'EnablePriceRefresh',
  ENABLE_PSS_UI_REFRESH: 'EnablePssUiRefresh',
  ENABLE_RANKING_EXPLANATION_WRAPPER: 'enable_ranking_explanation_wrapper',
  ENABLE_RELEVANT_DIGITAL_AS_PREBID_PROVIDER: 'enableRelevantDigitalAsPrebidProvider',
  ENABLE_SAVE_TRIP_MENU: 'EnableSaveTripMenu',
  ENABLE_SEARCH_RESULTS_LOYALTY_DISCOUNTS: 'enable_search_results_loyalty_discounts',
  ENABLE_SHORT_TRANSFER_WARNING_MESSAGE: 'EnableShortTransferWarningMessage',
  ENABLE_SINGLE_LEG_RESULTS_LEG_PINS: 'EnableSingleLegResultsLegPins',
  ENABLE_SINGLE_LEG_RESULTS_MULTI_STEP: 'EnableSingleLegResultsMultiStep',
  ENABLE_SPICY_HOMEPAGE_VIDEO_PLAYER: 'EnableSpicyHomepageVideoPlayer',
  ENABLE_SPONSORED_BOOKING_PANEL_ACORN: 'EnableSponsoredBookingPanelAcorn',
  ENABLE_SPONSORED_BOOKING_PANEL_ADVERT: 'enable_sponsored_booking_panel_advert',
  ENABLE_SPONSORED_CONTENT_IN_COMBINED_RESULTS: 'EnableSponsoredContentInCombinedResults',
  ENABLE_SQUARE_LOGOS: 'enable_square_logos',
  ENABLE_TCS: 'EnableTcs',
  ENABLE_UPGRADE_MESSAGING_IN_SEARCH_RESULTS: 'EnableUpgradeMessagingInSearchResults',
  ENABLE_UPGRADE_MESSAGING_ON_SEARCH_RESULTS_PAGE: 'EnableUpgradeMessagingOnSearchResultsPage',
  ENABLE_UPSELL_FARE_DIFFERENCE: 'EnableUpsellFareDifference',
  ENABLE_VERTICALS_ORDERING: 'EnableVerticalsOrdering',
  ENABLE_WEB_TO_APP_BANNERS: 'enable_web_to_app_banners',
  ENABLE_WEB_TO_APP_BANNERS_BANANA: 'enable_web_to_app_banners_banana',
  EXPLORE_CITY_COUNTRY_POC_VARIANT: 'explore_city_country_poc_variant',
  EXPLORE_EVERYWHERE_PREMIUM_CABIN_RAIL_VARIANT: 'ExploreEverywherePremiumCabinRailVariant',
  HEADER_REDUCED_VERTICAL_SPACING: 'HeaderReducedVerticalSpacing',
  HOMEPAGE_DROPS_ENABLED: 'homepage_drops_enabled',
  HOMEPAGE_DROPS_UI_ENABLED: 'homepage_drops_ui_enabled',
  HOMEPAGE_DROPS_VARIANT: 'homepage_drops_variant',
  HOMEPAGE_PARALLEL_SEARCH_CONSENT_ENABLED: 'homepage_parallel_search_consent_enabled',
  HOTELS_HEADER_TAB_BUBBLE_ENABLED: 'hotels_header_tab_bubble_enabled',
  HOTEL_REDIRECT_PRICE_CONSISTENCY: 'HotelRedirectPriceConsistency',
  INITIAL_FLIGHT_PRICING_OPTIONS_COUNT: 'InitialFlightPricingOptionsCount',
  INTERNAL_LINKING_LATEST_VERSION: 'internal_linking_latest_version',
  MARKETS_ENABLED_RTS: 'markets_enabled_rts',
  NATIVE_BOTTOM_CAR_HIRE_XSELL: 'native_bottom_car_hire_xsell',
  NATIVE_BOTTOM_HOTELS_XSELL: 'native_bottom_hotels_xsell',
  OTA_LOGOS_IN_RESULTS: 'ota_logos_in_results',
  PACKAGES_ENABLE_RTS: 'PackagesEnableRTS',
  PACKAGES_ENTRY_POINT_CTA_TEXT: 'packages_entry_point_cta_text',
  PACKAGES_ENTRY_POINT_VALUE_TEXT: 'packages_entry_point_value_text',
  PACKAGES_HEADER_TAB_ENABLED: 'packages_header_tab_enabled',
  PACKAGES_HEADER_TAB_ENABLED_DESKTOP: 'packages_header_tab_enabled_desktop',
  PACKAGES_HEADER_TAB_VERSION: 'packages_header_tab_version',
  PACKAGES_HEADER_TAB_VERSION_VISUAL_DESKTOP: 'packages_header_tab_version_visual_desktop',
  PACKAGES_PARALLEL_SEARCH_DEFAULT_VALUE: 'PackagesParallelSearchDefaultValue',
  PACKAGES_PARALLEL_SEARCH_LABEL: 'PackagesParallelSearchLabel',
  PACKAGES_UP_SELL_DELAY: 'PackagesUpSellDelay',
  PARALLEL_SEARCH_DEFAULT_VALUE: 'ParallelSearchDefaultValue',
  PARALLEL_SEARCH_LABEL: 'ParallelSearchLabel',
  PARALLEL_SEARCH_OPTION_POSITION: 'ParallelSearchOptionPosition',
  PARALLEL_SEARCH_REDIRECT_BEHAVIOUR: 'ParallelSearchRedirectBehaviour',
  PAYMENT_DISCOUNT_INDIA_PHASE_2: 'payment_discount_india_phase_2',
  PAYMENT_DISCOUNT_KOREA_PHASE_2: 'payment_discount_korea_phase_2',
  POC_PERSIST_REFERRER: 'PocPersistReferrer',
  POSITION_OF_RAIL_BANNER: 'position_of_rail_banner',
  PQS_SUMMARY_AGENT_FILTER: 'PqsSummaryAgentFilter',
  PRE_KONDO_BOOKING_PANEL_LOADING: 'PreKondoBookingPanelLoading',
  PRICE_PULSE_ENABLED: 'PricePulseEnabled',
  PRICE_PULSE_THRESHOLD_PERCENT: 'PricePulseThresholdPercent',
  PRICE_PULSE_UI_ENABLED: 'PricePulseUIEnabled',
  PRIMARY_NAV_IN_FSS: 'primary_nav_in_fss',
  RANK_EXPLAINABILITY_ML_ENABLED: 'rank_explainability_ml_enabled',
  REMOVE_CHROME_RESTRICTION_GOT: 'remove_chrome_restriction_got',
  RENDER_SPONSORED_BOOKING_PANEL_ADVERT: 'render_sponsored_booking_panel_advert',
  RTS_MAX_PASSENGERS_RESTRICTION: 'rts_max_passengers_restriction',
  S2L_BOOKING_PANEL_BOTTOM_SHEET_CTA_EXPERIMENT: 'S2L_Booking_Panel_BottomSheet_CTA_Experiment',
  SHOW_AIRLINE_TAG: 'show_airline_tag',
  SHOW_COMBINED_RESULTS_BOTTOM_GOOGLE_ADVERT: 'ShowCombinedResultsBottomGoogleAdvert',
  SHOW_PACKAGES_BANNER: 'show_packages_banner',
  SHOW_PARTNER_MESSAGES: 'ShowPartnerMessages',
  SHOW_PQS_MODAL: 'ShowPqsModal',
  SHOW_PQS_NUMERICAL_RATING: 'show_pqs_numerical_rating',
  SHOW_PQS_SURVEY_ON_ACORN: 'show_pqs_survey_on_acorn',
  SHOW_PRICE_BAND_FAIR_PRICE_SIGNAL: 'show_price_band_fair_price_signal',
  SHOW_PRICE_GRID: 'ShowPriceGrid',
  SHOW_SPONSORED_BOOKING_PANEL_DESKTOP: 'show_sponsored_booking_panel_desktop',
  SHOW_UNPRICED_OPTION: 'show_unpriced_option',
  SKIP_ACCOMMODATION_CARHIRE_FROM_RADAR: 'SkipAccommodationCarhireFromRadar',
  SPONSORED_AIRLINES_DRAWER_ENABLED: 'SponsoredAirlinesDrawerEnabled',
  SPONSORED_AIRLINES_V2_DIRECT_BOOKING_PANEL: 'sponsored_airlines_v2_direct_booking_panel',
  SPONSORED_AIRLINES_V2_DISPLAY: 'sponsored_airlines_v2_display',
  SPONSORED_AIRLINES_V2_USE_CARRIER_ID_FILTER: 'sponsored_airlines_v2_use_carrier_id_filter',
  SPONSORED_DESTINATION_V2_DISPLAY: 'sponsored_destination_v2_display',
  STAYS_COPY_HEADER_TAB_ENABLED: 'stays_copy_header_tab_enabled',
  SUMMARY_ON_BP_BANANA_ENABLED: 'summary_on_bp_banana_enabled',
  SWAP_PLACEDISPLAYCODE_AND_PLACENAME_BOOKING_PANEL:
    'swap_placedisplaycode_and_placename_booking_panel',
  SYNC_EVENTS_MAP_AND_LIST: 'SyncEventsMapAndList',
  TTFR_EXPERIMENT_DELAY_MS: 'ttfr_experiment_delay_ms',
  USE_ACCOMMODATION_RESULTS_IN_SAM_NATIVE_BOTTOM_HOTELS_XSELL:
    'use_accommodation_results_in_sam_bottom_hotels_xsell',
  USE_ITINERARY_TOKEN: 'use_itinerary_token',
  USE_NEW_TRACKING_ENDPOINT: 'use_new_tracking_endpoint',
  WEB_TO_APP_BANNER_ID: 'web_to_app_banner_id',
  WEB_TO_APP_INITIALISATION_KEY_PROD: 'web_to_app_initialisation_key_prod',
  WEB_TO_APP_INITIALISATION_KEY_TEST: 'web_to_app_initialisation_key_test',
  WHOLE_CARD_CLICKABLE: 'WholeCardClickable',
  XSELL_BOOKING_PANEL_LOADING: 'xsell_booking_panel_loading',
} as const;

export const RELEASE = {
  ADS_DSA_MODAL_UPDATED_WITH_LEGAL_NAME_WEB: 'ads_dsa_modal_updated_with_legal_name_web',
  ENABLE_ACORN_SEARCH_RESULTS_PAGE_ON_DIRECT_BP_LANDING:
    'EnableAcornSearchResultsPageOnDirectBpLanding',
  ENABLE_BANANA_GRAPPLER_TOPIC_FILTER_INTERACTION_TRIGGERED:
    'enable_banana_grappler_topic_filter_interaction_triggered',
  ENABLE_DESTINATION_GUIDEBOOK: 'destination_guidebook_enabled',
  ENABLE_FILTERED_DAY_VIEW: 'filtered_day_view_enabled',
  ENABLE_SPONSORED_BOOKING_PANEL_DESKTOP: 'EnableSponsoredBookingPanelDesktop',
  ENABLE_SPONSORED_DESTINATION_DAY_VIEW: 'sponsored_destination_day_view_enabled',
  ENABLE_STAYS_NAVCARD: 'EnableStaysNavcard',
  ENABLE_STREVDA_ADS_AFTER_GUIDEBOOK: 'strevda_ads_after_guidebook_enabled',
  RBB_COPY_UPDATE: 'rbb_copy_update',
  STREDVA_RUNTIME_VERSION: 'Component_strevda-runtime_Version',
  STREVDA_RUNTIME_REREQUEST_ENABLED: 'strevda_runtime_rerequest_enabled',
} as const;

export const OPS = {
  AIRSPACE_CLOSURE_BANNER_COUNTRIES_LIST: 'airspace_closure_banner_countries_list',
  ALLOW_LOCAL_TLD_REDIRECT: 'AllowLocalTldRedirect',
  APP_STORE_LINK: 'appStoreLink',
  BLOCKED_MARKETING_CARRIER_LOGOS: 'BlockedMarketingCarrierLogos',
  BOOKING_CONFIDENCE_MESSAGE_EXPIRY_DAYS: 'BookingConfidenceMessageExpiryDays',
  BOOKING_CONFIDENCE_MESSAGE_EXPIRY_DAYS_ACORN: 'BookingConfidenceMessageExpiryDaysAcorn',
  CONSENT_ID_SERVICE_URL: 'consentIdServiceUrl',
  DAYVIEW_INITIAL_RESULT_COUNT: 'DAYVIEW_INITIAL_RESULT_COUNT',
  DEAL_BADGE_THRESHOLD: 'DealBadgeThreshold',
  DISABLE_S2L_FOR_BAGGAGE_SEARCH: 'disableS2LForBaggageSearch',
  DOLPHINS_FIXTURE_DATES: 'DolphinsFixtureDates',
  ENABLE_ACORN_GTM_INTEGRATION: 'EnableAcornGtmIntegration',
  ENABLE_ADJUST_HOTEL_PRICE: 'enableAdjustHotelPrice',
  ENABLE_AIRSPACE_CLOSURE_BANNER: 'enable_airspace_closure_banner',
  ENABLE_AIRSPACE_CLOSURE_BANNER_LAYOVERS: 'enable_airspace_closure_banner_layovers',
  ENABLE_ARGENTINA_BANNER: 'argentina_banner_enabled',
  ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_DESKTOP: 'EnableBaggageFilterInSearchResultsDesktop',
  ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_MWEB: 'EnableBaggageFilterInSearchResultsMweb',
  ENABLE_BANANA_GTM_INTEGRATION: 'EnableBananaGtmIntegration',
  ENABLE_BP_SOLO_ACT_LOGGING: 'EnableBpSoloActLogging',
  ENABLE_CITY_DRAWER_COUNTRY_VIEW: 'EnableCityDrawerCountryView',
  ENABLE_COMBINED_EXPLORE_ANYTIME_SEARCH: 'EnableCombinedExploreAnytimeSearch',
  ENABLE_COMPRESS_GRAPHIC_PROMO_MOBILE: 'EnableCompressGraphicPromoMobile',
  ENABLE_CONSENT_ID_SERVICE: 'enableConsentIdService',
  ENABLE_CONSENT_MANAGEMENT: 'enableConsentManagement',
  ENABLE_COOKIE_VERSION_ROLLBACK: 'enableCookieVersionRollback',
  ENABLE_DOLPHINS_CONFIG_DATA: 'EnableDolphinsConfigData',
  ENABLE_DOLPHINS_PRICING: 'EnableDolphinsPricing',
  ENABLE_GLOBAL_NAVIGATION: 'EnableGlobalNavigation',
  ENABLE_GOOGLE_ONE_TAP: 'EnableGoogleOneTap',
  ENABLE_GOOGLE_ONE_TAP_BANANA: 'EnableGoogleOneTapBanana',
  ENABLE_GOOGLE_TAG_MANAGER: 'enable_google_tag_manager',
  ENABLE_GRAPHIC_PROMO: 'EnableGraphicPromo',
  ENABLE_GRAPPLER_INTEGRATION: 'EnableGrapplerIntegration',
  ENABLE_HOMEPAGE_HERO: 'EnableHomepageHero',
  ENABLE_INTERNAL_LINKING: 'EnableInternalLinking',
  ENABLE_INTERNATIONAL_SITES: 'enable_international_sites',
  ENABLE_INVALID_PAGE_TYPE_404: 'EnableInvalidPageType404',
  ENABLE_KETCH_CMP: 'enableKetchCMP',
  ENABLE_KETCH_PSID_SYNC: 'enableKetchPsidSync',
  ENABLE_LEGACY_CONSENT_SYNC: 'enableLegacyConsentSync',
  ENABLE_MEXICO_BANNER: 'mexico_banner_enabled',
  ENABLE_MOROCCO_RAMADAN_BANNER: 'EnableMoroccoRamadanBanner',
  ENABLE_PERIMETER_X: 'enable_perimeter_x',
  ENABLE_PERIMETER_X_FOR_ACORN: 'enable_perimeter_x_for_acorn',
  ENABLE_PERIMETER_X_FOR_BANANA: 'enable_perimeter_x_for_banana',
  ENABLE_PRERENDER: 'EnablePrerender',
  ENABLE_PRICE_ALERT_SIGNUP_ON_MWEB: 'EnablePriceAlertSignupOnMweb',
  ENABLE_PRICE_CALENDAR_DATA: 'EnablePriceCalendarData',
  ENABLE_PURPOSE_SCOPED_ID_EXISTING_GDPR_USERS: 'enablePurposeScopedIdExistingGDPRUsers',
  ENABLE_PURPOSE_SCOPED_ID_NON_REGULATED_MARKETS: 'enablePurposeScopedIdNonRegulatedMarkets',
  ENABLE_PURPOSE_SCOPED_ID_SERVICE: 'enablePurposeScopedIdService',
  ENABLE_RAIL: 'EnableRail',
  ENABLE_RUSSIA_BANNER: 'EnableRussiaBannerBanana',
  ENABLE_SAVE_TO_LIST: 'EnableSaveToList',
  ENABLE_SONAR_ALPHA: 'enable_sonar_alpha',
  ENABLE_SPINNER_TIMEOUT_LOGGING: 'EnableSpinnerTimeoutLogging',
  ENABLE_US_BELARUS_BANNER: 'EnableUSBelarusBanner',
  FOOTER_APP_DOWNLOAD_TRACKING_LINK: 'footerAppDownloadTrackingLink',
  FPS_DEGRADATION_SLOW_DOWN_POLLING: 'fps_degradation_slow_down_polling',
  GAM_ADS_INITIAL_DELAY: 'GamAdsInitialDelay',
  GOOGLE_CLIENT_ID_DEV: 'GoogleClientIdDev',
  GOOGLE_CLIENT_ID_PROD: 'GoogleClientIdProd',
  GOOGLE_PLAY_LINK: 'googlePlayLink',
  HIDDEN_PQS_PARTNERS: 'ABS_hide_pqs_partners',
  HOTELS_CAROUSEL_WIDGET_SORTING: 'Component_hotels-carousel-widget_Sorting',
  IS_INTERNAL_TRAFFIC: 'is_internal_traffic',
  KAKAOPAY_CASHBACK_PERCENTAGE: 'kakaopay_cashback_percentage',
  KETCH_CONSENT_COOKIE_NAME: 'ketchConsentCookieName',
  KETCH_SCRIPT_URL: 'ketchScriptUrl',
  KETCH_TCF_STORAGE_KEY: 'ketchTCFStorageKey',
  LONG_CURRENCIES_LIST: 'long_currencies_list',
  NUMBER_OF_ADDITIONAL_ADS_ON_INITIAL_RESULTS: 'banana_number_of_additional_ads_on_initial_results',
  PACKAGES_ALLOWED_DESTINATIONS: 'packages_allowed_destinations',
  PACKAGES_DISALLOWED_DESTINATION_COUNTRIES: 'packages_disallowed_destination_countries',
  PACKAGES_MARKETS_ENABLED: 'packages_markets_enabled',
  PARTNERS_WITH_EITHER_PERSONAL_OR_CARRY_ON: 'partners_with_either_personal_or_carry_on',
  PARTNERS_WITH_KAKAO_PAY_CASHBACK: 'partners_with_kakao_pay_cashback',
  PERSONAL_ITEM_NOT_INCLUDED_CARRIER_IDS: 'PersonalItemNotIncludedCarrierIDs',
  PQS_FEEDBACK_FORM_PRESENTATION_DELAY: 'PQS_Feedback_Form_Presentation_Delay',
  PQS_FEEDBACK_FORM_PRESENTATION_DELAY_DESKTOP: 'pqs_feedback_form_presentation_delay_desktop',
  PRICE_ALERTS_API_BASE_ENDPOINT: 'PriceAlertsApiBaseEndpoint',
  PRICE_ALERTS_ENABLED: 'price_alerts_enabled',
  PRICE_REFRESH_INTERVAL: 'PriceRefreshInterval',
  PURPOSE_SCOPED_ID_SERVICE_KETCH_CMP_URL: 'purposeScopedIdServiceKetchCmpUrl',
  PURPOSE_SCOPED_ID_SERVICE_LEGACY_CMP_URL: 'purposeScopedIdServiceLegacyCmpUrl',
  REDIRECT_TO_BOOKING_PANEL: 'redirect_to_booking_panel',
  RESULTS_INTERVAL_BETWEEN_INLINE_ADS: 'banana_interval_between_inline_ads',
  RESULT_ELEMENTS_PER_SCROLL: 'result_elements_per_scroll',
  SAVED_EXPERIENCE_API_BASE_ENDPOINT: 'SavedExperienceApiBaseEndpoint',
  SEARCH_RESULTS_OPTION_EVENT_AMOUNT: 'search_results_option_amount',
  SERVE_PRE_RELEASE_LOCALES: 'serve_pre_release_locales',
  SHOW_COMBINED_RESULTS_CAR_HIRE: 'ShowCombinedResultsCarHire',
  SHOW_COMBINED_RESULTS_HOTELS: 'ShowCombinedResultsHotels',
  SHOW_ECO_FILTER: 'TERRA_show_eco_filter',
  SHOW_GOOGLE_INLINE_ADS: 'ShowGoogleInlineAds',
  SHOW_INLINE_ADS: 'ShowInlineAds',
  SHOW_LOCALE_CODE: 'showLocaleCode',
  SHOW_PQS_SCORE: 'show_pqs_score',
  TOTAL_NUMBER_OF_VENDORS: 'totalNumberOfVendors',
  TRANSPARENCY_CONSENT_FRAMEWORK_CONFIG_VERSION: 'transparencyConsentFrameworkConfigVersionNumber',
} as const;

export const DATA = {
  FSS_MARKET_PROVIDER_FEATURES: 'fss_market_provider_features',
} as const;

export const CONFIG_SERVICE_KEYS = {
  EXPERIMENT,
  RELEASE,
  OPS,
  DATA,
} as const;
